import { Snackbar, Alert } from "@mui/material";

export function WpAlert(props: any) {
    const handleClose = (event: any, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }

        props.setOpen(false);
    };

    return (
        <Snackbar open={props.open} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}>
            <Alert severity={props.severity} >{props.message}</Alert>
        </Snackbar>
    );
}
